// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1STub","log":"ModalInventoryLogs_log__3IaUQ","date":"ModalInventoryLogs_date__bbl-S","userName":"ModalInventoryLogs_userName__2xPKD"};